import tabs from './content-tabs';
const $ = jQuery.noConflict();

const controlsSlider = {
    controls: $('.block-full-page-slider__controls-wrapper'),

    initSlider() {
        $(this).slick({
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            pauseOnHover: false,
            autoplay: false,
            infinite:true,
            centerMode : true,
        });
            $('.slick-slider').on('click', '.slick-slide', function (e) {
            e.stopPropagation();
            var index = $(this).data("slick-index");
            if ($('.slick-slider').slick('slickCurrentSlide') !== index) {
              $('.slick-slider').slick('slickGoTo', index);
            }

            tabs.init( $(this) );
          });

          $('.slick-slider').on('swipe', function(event, slick, direction){
            let current = $('.slick-current');
            tabs.init(current);
          });

          let next = $('.block-full-page-slider__controls-wrapper').find('.slick-next');
          next.on('click', function(e){
            let current = $('.slick-current');
            tabs.init(current);
          });

          let prev = $('.block-full-page-slider__controls-wrapper').find('.slick-prev');
          prev.on('click', function(e){
            let current = $('.slick-current');
            tabs.init(current);
          });
    },
    init() {
        if (this.controls) {
            this.controls.each(this.initSlider);
        }
    }
}

export default controlsSlider;